import { __rest } from "tslib";
import React from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { Button } from '../..';
import { reactStyling, tokens } from '@getgo/chameleon-core';
const useStyles = makeStyles((theme) => {
    const { iconButton, iconButtonXsmall, iconButtonXsmallIcon, iconButtonSmall, iconButtonSmallIcon, iconButtonLarge, iconButtonLargeIcon, iconButtonHover, iconButtonActive, iconButtonFocus, iconButtonDisabled, iconButtonDisabledIcon, } = reactStyling(theme.tokens);
    return {
        iconButton: Object.assign(Object.assign({}, iconButton), { '--goto-icon-size': '24px', minWidth: 'unset !important', '&:hover': Object.assign({}, iconButtonHover), '&.Mui-focusVisible': Object.assign({}, iconButtonFocus), '&:active': Object.assign({}, iconButtonActive), '&:disabled': Object.assign(Object.assign({}, iconButtonDisabled), { '& chameleon-svg': Object.assign({}, iconButtonDisabledIcon) }), '& chameleon-svg': {
                color: tokens.icon01,
            } }),
        primary: {},
        secondary: {
            '& chameleon-svg': {
                color: tokens.icon04,
            },
        },
        neutral: {
            '& chameleon-svg': {
                color: tokens.icon03,
            },
        },
        xsmall: Object.assign(Object.assign({}, iconButtonXsmall), { '--goto-icon-size': '18px', '& chameleon-svg': Object.assign({}, iconButtonXsmallIcon) }),
        small: Object.assign(Object.assign({}, iconButtonSmall), { '--goto-icon-size': '20px', '& chameleon-svg': Object.assign({}, iconButtonSmallIcon) }),
        large: Object.assign(Object.assign({}, iconButtonLarge), { '--goto-icon-size': '30px', '& chameleon-svg': Object.assign({}, iconButtonLargeIcon) }),
    };
});
export const IconButton = React.forwardRef((_a, ref) => {
    var { className, size, children, variant } = _a, otherProps = __rest(_a, ["className", "size", "children", "variant"]);
    const classes = useStyles();
    return (React.createElement(Button, Object.assign({ ref: ref, className: clsx(classes.iconButton, size && size !== 'medium' ? classes[size] : '', classes[variant !== null && variant !== void 0 ? variant : 'primary'], className) }, otherProps), children));
});
